import { styled } from "@mui/material/styles";
import AutoAwesome from "@mui/icons-material/AutoAwesome";
export const SparkleIcon = styled(AutoAwesome)(({ theme }) => ({
  fontSize: 14,
  color:
    theme.palette.mode === "dark"
      ? theme.palette.grey[400]
      : theme.palette.grey[500],
}));
